window.ST_CAR_FIT_DATA = {
  "version": "V449_shopify_card_data_refresh",
  "source": "products_export_cleaned_stereotip.csv / V448 shopify_vehicle_coverage",
  "fitmentKeyMetafield": "custom.fitment_key",
  "productTypes": [
    {
      "value": "all",
      "label": "כל המוצרים",
      "target": "/collections/car-fit-results?view=no-usf",
      "enabled": true
    },
    {
      "value": "multimedia",
      "label": "מסך מולטימדיה לפי דגם רכב",
      "target": "/collections/car-fit-results?view=no-usf",
      "enabled": true
    },
    {
      "value": "window_lifter",
      "label": "מרימי שמשות",
      "target": "/collections/car-fit-results?view=no-usf",
      "enabled": true
    },
    {
      "value": "sunshade",
      "label": "מגן שמש בהתאמה אישית",
      "target": "/collections/car-fit-results?view=no-usf",
      "enabled": true
    },
    {
      "value": "floor_mats",
      "label": "שטיחים בהתאמה אישית",
      "target": "/collections/car-fit-results?view=no-usf",
      "enabled": true
    },
    {
      "value": "roof",
      "label": "גגונים ותאי חפצים",
      "target": "/collections/car-fit-results?view=no-usf",
      "enabled": false
    },
    {
      "value": "bike",
      "label": "מנשאים - בקרוב",
      "target": "/collections/car-fit-results?view=no-usf",
      "enabled": false
    },
    {
      "value": "accessories",
      "label": "אביזרים - בקרוב",
      "target": "/collections/car-fit-results?view=no-usf",
      "enabled": false
    }
  ],
  "productTargets": {
    "all": "/collections/car-fit-results?view=no-usf",
    "multimedia": "/collections/car-fit-results?view=no-usf",
    "window_lifter": "/collections/car-fit-results?view=no-usf",
    "sunshade": "/collections/car-fit-results?view=no-usf",
    "floor_mats": "/collections/car-fit-results?view=no-usf",
    "roof": "/collections/car-fit-results?view=no-usf",
    "bike": "/collections/car-fit-results?view=no-usf",
    "accessories": "/collections/car-fit-results?view=no-usf"
  },
  "categoryCounts": {
    "floor_mats": 84,
    "window_lifter": 181,
    "sunshade": 53,
    "multimedia": 109
  },
  "coverageCount": 256,
  "makesCount": 44,
  "productsWithFitment": 670,
  "duplicateCleanup": {
    "liveDuplicateGroupCount": 0,
    "canonicalKeys": [
      "hyundai__i20",
      "isuzu__dmax",
      "mazda__cx3",
      "mazda__cx5",
      "nissan__x-trail"
    ],
    "oldDuplicateKeysRemoved": [
      "hyundai__i-20",
      "isuzu__dy-mks",
      "isuzu__dymks",
      "mazda__cx-3",
      "mazda__cx-5",
      "nissan__aks-tryyl",
      "nissan__akstryyl"
    ]
  },
  "makes": [
    {
      "label": "BMW",
      "value": "bmw",
      "types": [
        "window_lifter"
      ],
      "models": [
        {
          "label": "X1",
          "value": "x1",
          "years": [
            "1999",
            "2000",
            "2001",
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "bmw__x1",
          "displayName": "BMW X1"
        },
        {
          "label": "X4",
          "value": "x4",
          "years": [
            "1999",
            "2000",
            "2001",
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "bmw__x4",
          "displayName": "BMW X4"
        },
        {
          "label": "סדרה 1",
          "value": "series_1",
          "years": [
            "1999",
            "2000",
            "2001",
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "bmw__series_1",
          "displayName": "BMW סדרה 1"
        },
        {
          "label": "סדרה 5",
          "value": "series_5",
          "years": [
            "1999",
            "2000",
            "2001",
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "bmw__series_5",
          "displayName": "BMW סדרה 5"
        },
        {
          "label": "סדרה 7",
          "value": "series_7",
          "years": [
            "1999",
            "2000",
            "2001",
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "bmw__series_7",
          "displayName": "BMW סדרה 7"
        }
      ]
    },
    {
      "label": "BYD",
      "value": "byd",
      "types": [
        "window_lifter",
        "sunshade"
      ],
      "models": [
        {
          "label": "ATTO 3",
          "value": "atto-3",
          "years": [
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "sunshade": [
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter",
            "sunshade"
          ],
          "coverageKey": "byd__atto-3",
          "displayName": "BYD ATTO 3"
        },
        {
          "label": "Dolphin",
          "value": "dolphin",
          "years": [
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "byd__dolphin",
          "displayName": "BYD Dolphin"
        }
      ]
    },
    {
      "label": "GAC",
      "value": "gac",
      "types": [
        "window_lifter"
      ],
      "models": [
        {
          "label": "GAC חשמלי",
          "value": "gac_ev",
          "years": [
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "gac__gac_ev",
          "displayName": "GAC GAC חשמלי"
        }
      ]
    },
    {
      "label": "GMC",
      "value": "gmc",
      "types": [
        "window_lifter"
      ],
      "models": [
        {
          "label": "GMC",
          "value": "gmc",
          "years": [
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "gmc__gmc",
          "displayName": "GMC GMC"
        }
      ]
    },
    {
      "label": "KGM",
      "value": "kgm",
      "types": [
        "window_lifter"
      ],
      "models": [
        {
          "label": "טורס",
          "value": "torres",
          "years": [
            "2024"
          ],
          "yearsByType": {
            "all": [
              "2024"
            ],
            "window_lifter": [
              "2024"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "kgm__torres",
          "displayName": "KGM טורס"
        }
      ]
    },
    {
      "label": "Lynk & Co",
      "value": "lynk_co",
      "types": [
        "window_lifter"
      ],
      "models": [
        {
          "label": "Lynk & Co",
          "value": "lynk_co",
          "years": [
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "lynk_co__lynk_co",
          "displayName": "Lynk & Co Lynk & Co"
        }
      ]
    },
    {
      "label": "MG",
      "value": "mg",
      "types": [
        "window_lifter"
      ],
      "models": [
        {
          "label": "MG3",
          "value": "mg3",
          "years": [
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2025"
            ],
            "window_lifter": [
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "mg__mg3",
          "displayName": "MG MG3"
        },
        {
          "label": "MG4",
          "value": "mg4",
          "years": [
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2025"
            ],
            "window_lifter": [
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "mg__mg4",
          "displayName": "MG MG4"
        },
        {
          "label": "ZS",
          "value": "zs",
          "years": [
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "mg__zs",
          "displayName": "MG ZS"
        }
      ]
    },
    {
      "label": "אאודי",
      "value": "audi",
      "types": [
        "floor_mats"
      ],
      "models": [
        {
          "label": "A3",
          "value": "a3",
          "years": [
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020"
          ],
          "yearsByType": {
            "all": [
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020"
            ],
            "floor_mats": [
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020"
            ]
          },
          "productTypes": [
            "floor_mats"
          ],
          "coverageKey": "audi__a3",
          "displayName": "אאודי A3"
        },
        {
          "label": "Q3",
          "value": "q3",
          "years": [
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018"
          ],
          "yearsByType": {
            "all": [
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018"
            ],
            "floor_mats": [
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018"
            ]
          },
          "productTypes": [
            "floor_mats"
          ],
          "coverageKey": "audi__q3",
          "displayName": "אאודי Q3"
        },
        {
          "label": "Q5",
          "value": "q5",
          "years": [
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017"
          ],
          "yearsByType": {
            "all": [
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017"
            ],
            "floor_mats": [
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017"
            ]
          },
          "productTypes": [
            "floor_mats"
          ],
          "coverageKey": "audi__q5",
          "displayName": "אאודי Q5"
        }
      ]
    },
    {
      "label": "אופל",
      "value": "opel",
      "types": [
        "window_lifter"
      ],
      "models": [
        {
          "label": "אסטרה",
          "value": "astra",
          "years": [
            "1999",
            "2000",
            "2001",
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "opel__astra",
          "displayName": "אופל אסטרה"
        },
        {
          "label": "מוקה",
          "value": "mokka",
          "years": [
            "1999",
            "2000",
            "2001",
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "opel__mokka",
          "displayName": "אופל מוקה"
        },
        {
          "label": "קומבו",
          "value": "combo",
          "years": [
            "1999",
            "2000",
            "2001",
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "opel__combo",
          "displayName": "אופל קומבו"
        },
        {
          "label": "קורסה",
          "value": "corsa",
          "years": [
            "1999",
            "2000",
            "2001",
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "opel__corsa",
          "displayName": "אופל קורסה"
        },
        {
          "label": "קרוסלנד",
          "value": "crossland",
          "years": [
            "1999",
            "2000",
            "2001",
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "opel__crossland",
          "displayName": "אופל קרוסלנד"
        }
      ]
    },
    {
      "label": "אינפיניטי",
      "value": "infiniti",
      "types": [
        "window_lifter"
      ],
      "models": [
        {
          "label": "QX30",
          "value": "qx30",
          "years": [
            "1999",
            "2000",
            "2001",
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "infiniti__qx30",
          "displayName": "אינפיניטי QX30"
        },
        {
          "label": "QX50",
          "value": "qx50",
          "years": [
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "infiniti__qx50",
          "displayName": "אינפיניטי QX50"
        },
        {
          "label": "QX60",
          "value": "qx60",
          "years": [
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "infiniti__qx60",
          "displayName": "אינפיניטי QX60"
        },
        {
          "label": "QX70",
          "value": "qx70",
          "years": [
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "infiniti__qx70",
          "displayName": "אינפיניטי QX70"
        },
        {
          "label": "QX80",
          "value": "qx80",
          "years": [
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "infiniti__qx80",
          "displayName": "אינפיניטי QX80"
        }
      ]
    },
    {
      "label": "איסוזו",
      "value": "isuzu",
      "types": [
        "window_lifter",
        "sunshade",
        "floor_mats"
      ],
      "models": [
        {
          "label": "D-Max",
          "value": "dmax",
          "years": [
            "2000",
            "2001",
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "sunshade": [
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019"
            ]
          },
          "productTypes": [
            "window_lifter",
            "sunshade",
            "floor_mats"
          ],
          "coverageKey": "isuzu__dmax",
          "displayName": "איסוזו D-Max"
        }
      ]
    },
    {
      "label": "ג'ילי",
      "value": "geely",
      "types": [
        "sunshade"
      ],
      "models": [
        {
          "label": "Geometry C",
          "value": "geometry-c",
          "years": [
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "sunshade": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "sunshade"
          ],
          "coverageKey": "geely__geometry-c",
          "displayName": "ג'ילי Geometry C"
        }
      ]
    },
    {
      "label": "ג'יפ",
      "value": "jeep",
      "types": [
        "window_lifter",
        "floor_mats"
      ],
      "models": [
        {
          "label": "גרנד וגוניר",
          "value": "grand_wagoneer",
          "years": [
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "jeep__grand_wagoneer",
          "displayName": "ג'יפ גרנד וגוניר"
        },
        {
          "label": "גרנד צ׳ירוקי",
          "value": "grnd-shyrvky",
          "years": [
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019"
            ]
          },
          "productTypes": [
            "window_lifter",
            "floor_mats"
          ],
          "coverageKey": "jeep__grnd-shyrvky",
          "displayName": "ג'יפ גרנד צ׳ירוקי"
        },
        {
          "label": "קומפאס",
          "value": "compass",
          "years": [
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "jeep__compass",
          "displayName": "ג'יפ קומפאס"
        },
        {
          "label": "רוביקון",
          "value": "rubicon",
          "years": [
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "jeep__rubicon",
          "displayName": "ג'יפ רוביקון"
        },
        {
          "label": "רנגייד",
          "value": "renegade",
          "years": [
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "jeep__renegade",
          "displayName": "ג'יפ רנגייד"
        },
        {
          "label": "רנגלר",
          "value": "rnglr",
          "years": [
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2014",
              "2015",
              "2016",
              "2017",
              "2018"
            ]
          },
          "productTypes": [
            "window_lifter",
            "floor_mats"
          ],
          "coverageKey": "jeep__rnglr",
          "displayName": "ג'יפ רנגלר"
        }
      ]
    },
    {
      "label": "ג׳נסיס",
      "value": "genesis",
      "types": [
        "window_lifter"
      ],
      "models": [
        {
          "label": "G60",
          "value": "g60",
          "years": [
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "genesis__g60",
          "displayName": "ג׳נסיס G60"
        },
        {
          "label": "G70",
          "value": "g70",
          "years": [
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "genesis__g70",
          "displayName": "ג׳נסיס G70"
        },
        {
          "label": "G80",
          "value": "g80",
          "years": [
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "genesis__g80",
          "displayName": "ג׳נסיס G80"
        },
        {
          "label": "GV70",
          "value": "gv70",
          "years": [
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "genesis__gv70",
          "displayName": "ג׳נסיס GV70"
        },
        {
          "label": "GV80",
          "value": "gv80",
          "years": [
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "genesis__gv80",
          "displayName": "ג׳נסיס GV80"
        }
      ]
    },
    {
      "label": "דאצ'יה",
      "value": "dacia",
      "types": [
        "window_lifter",
        "floor_mats"
      ],
      "models": [
        {
          "label": "דאסטר",
          "value": "dastr",
          "years": [
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter",
            "floor_mats"
          ],
          "coverageKey": "dacia__dastr",
          "displayName": "דאצ'יה דאסטר"
        },
        {
          "label": "סנדרו",
          "value": "sandero",
          "years": [
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "dacia__sandero",
          "displayName": "דאצ'יה סנדרו"
        }
      ]
    },
    {
      "label": "דודג",
      "value": "dodge",
      "types": [
        "floor_mats"
      ],
      "models": [
        {
          "label": "ראם",
          "value": "ram",
          "years": [
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024"
          ],
          "yearsByType": {
            "all": [
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024"
            ],
            "floor_mats": [
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024"
            ]
          },
          "productTypes": [
            "floor_mats"
          ],
          "coverageKey": "dodge__ram",
          "displayName": "דודג ראם"
        }
      ]
    },
    {
      "label": "הונדה",
      "value": "honda",
      "types": [
        "multimedia",
        "window_lifter",
        "sunshade",
        "floor_mats"
      ],
      "models": [
        {
          "label": "CRV",
          "value": "crv",
          "years": [
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018"
            ]
          },
          "productTypes": [
            "window_lifter",
            "floor_mats"
          ],
          "coverageKey": "honda__crv",
          "displayName": "הונדה CRV"
        },
        {
          "label": "HRV",
          "value": "hrv",
          "years": [
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021"
          ],
          "yearsByType": {
            "all": [
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021"
            ],
            "floor_mats": [
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021"
            ]
          },
          "productTypes": [
            "floor_mats"
          ],
          "coverageKey": "honda__hrv",
          "displayName": "הונדה HRV"
        },
        {
          "label": "אודסי",
          "value": "odyssey",
          "years": [
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "honda__odyssey",
          "displayName": "הונדה אודסי"
        },
        {
          "label": "אקורד",
          "value": "akvrd",
          "years": [
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021"
            ],
            "window_lifter": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter"
          ],
          "coverageKey": "honda__akvrd",
          "displayName": "הונדה אקורד"
        },
        {
          "label": "ג'אז",
          "value": "gaz",
          "years": [
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "sunshade": [
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020"
            ],
            "floor_mats": [
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "sunshade",
            "floor_mats"
          ],
          "coverageKey": "honda__gaz",
          "displayName": "הונדה ג'אז"
        },
        {
          "label": "סיוויק",
          "value": "syvvyk",
          "years": [
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "sunshade": [
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021"
            ]
          },
          "productTypes": [
            "window_lifter",
            "sunshade",
            "floor_mats"
          ],
          "coverageKey": "honda__syvvyk",
          "displayName": "הונדה סיוויק"
        },
        {
          "label": "סיטי",
          "value": "syty",
          "years": [
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia"
          ],
          "coverageKey": "honda__syty",
          "displayName": "הונדה סיטי"
        }
      ]
    },
    {
      "label": "טויוטה",
      "value": "toyota",
      "types": [
        "multimedia",
        "window_lifter",
        "sunshade",
        "floor_mats"
      ],
      "models": [
        {
          "label": "BZ4",
          "value": "bz4x",
          "years": [
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "toyota__bz4x",
          "displayName": "טויוטה BZ4"
        },
        {
          "label": "CHR",
          "value": "chr",
          "years": [
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021"
            ],
            "window_lifter": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "sunshade": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022"
            ],
            "floor_mats": [
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter",
            "sunshade",
            "floor_mats"
          ],
          "coverageKey": "toyota__chr",
          "displayName": "טויוטה CHR"
        },
        {
          "label": "RAV4",
          "value": "rav4",
          "years": [
            "1999",
            "2000",
            "2001",
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020"
            ],
            "window_lifter": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "sunshade": [
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018"
            ],
            "floor_mats": [
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter",
            "sunshade",
            "floor_mats"
          ],
          "coverageKey": "toyota__rav4",
          "displayName": "טויוטה RAV4"
        },
        {
          "label": "אבלון",
          "value": "ablvn",
          "years": [
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018"
          ],
          "yearsByType": {
            "all": [
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018"
            ],
            "multimedia": [
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018"
            ]
          },
          "productTypes": [
            "multimedia"
          ],
          "coverageKey": "toyota__ablvn",
          "displayName": "טויוטה אבלון"
        },
        {
          "label": "אוונסיס",
          "value": "avvnsys",
          "years": [
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018"
          ],
          "yearsByType": {
            "all": [
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018"
            ],
            "multimedia": [
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018"
            ],
            "floor_mats": [
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018"
            ]
          },
          "productTypes": [
            "multimedia",
            "floor_mats"
          ],
          "coverageKey": "toyota__avvnsys",
          "displayName": "טויוטה אוונסיס"
        },
        {
          "label": "אוריס",
          "value": "avrys",
          "years": [
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2017",
              "2018",
              "2019"
            ],
            "window_lifter": [
              "2015",
              "2016",
              "2017",
              "2018",
              "2019"
            ],
            "floor_mats": [
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter",
            "floor_mats"
          ],
          "coverageKey": "toyota__avrys",
          "displayName": "טויוטה אוריס"
        },
        {
          "label": "אייגו",
          "value": "ayygv",
          "years": [
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021"
            ],
            "window_lifter": [
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter"
          ],
          "coverageKey": "toyota__ayygv",
          "displayName": "טויוטה אייגו"
        },
        {
          "label": "היילנדר",
          "value": "highlander",
          "years": [
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2025"
            ],
            "window_lifter": [
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "toyota__highlander",
          "displayName": "טויוטה היילנדר"
        },
        {
          "label": "היילקס",
          "value": "hyylks",
          "years": [
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023"
            ],
            "window_lifter": [
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter",
            "floor_mats"
          ],
          "coverageKey": "toyota__hyylks",
          "displayName": "טויוטה היילקס"
        },
        {
          "label": "ורסו",
          "value": "vrsv",
          "years": [
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018"
            ],
            "window_lifter": [
              "2015",
              "2016",
              "2017",
              "2018",
              "2019"
            ],
            "floor_mats": [
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter",
            "floor_mats"
          ],
          "coverageKey": "toyota__vrsv",
          "displayName": "טויוטה ורסו"
        },
        {
          "label": "יאריס",
          "value": "yarys",
          "years": [
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017"
            ],
            "window_lifter": [
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2025"
            ],
            "sunshade": [
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter",
            "sunshade",
            "floor_mats"
          ],
          "coverageKey": "toyota__yarys",
          "displayName": "טויוטה יאריס"
        },
        {
          "label": "יאריס קרוס",
          "value": "yaris_cross",
          "years": [
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2025"
            ],
            "window_lifter": [
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "toyota__yaris_cross",
          "displayName": "טויוטה יאריס קרוס"
        },
        {
          "label": "לנד קרוזר",
          "value": "land-cruiser",
          "years": [
            "1999",
            "2000",
            "2001",
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2025"
            ],
            "multimedia": [
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020"
            ],
            "window_lifter": [
              "2025"
            ],
            "sunshade": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021"
            ],
            "floor_mats": [
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter",
            "sunshade",
            "floor_mats"
          ],
          "coverageKey": "toyota__land-cruiser",
          "displayName": "טויוטה לנד קרוזר"
        },
        {
          "label": "סיינה",
          "value": "syanh",
          "years": [
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter"
          ],
          "coverageKey": "toyota__syanh",
          "displayName": "טויוטה סיינה"
        },
        {
          "label": "פרואייס",
          "value": "proace",
          "years": [
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "toyota__proace",
          "displayName": "טויוטה פרואייס"
        },
        {
          "label": "פריוס",
          "value": "pryvs",
          "years": [
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022"
          ],
          "yearsByType": {
            "all": [
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022"
            ],
            "multimedia": [
              "2009",
              "2010",
              "2011",
              "2012",
              "2013"
            ],
            "window_lifter": [
              "2015",
              "2016",
              "2017",
              "2018",
              "2019"
            ],
            "sunshade": [
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter",
            "sunshade"
          ],
          "coverageKey": "toyota__pryvs",
          "displayName": "טויוטה פריוס"
        },
        {
          "label": "פריוס פלוס",
          "value": "pryvs-plvs",
          "years": [
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022"
          ],
          "yearsByType": {
            "all": [
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022"
            ],
            "multimedia": [
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017"
            ],
            "window_lifter": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter"
          ],
          "coverageKey": "toyota__pryvs-plvs",
          "displayName": "טויוטה פריוס פלוס"
        },
        {
          "label": "קאמרי",
          "value": "kamry",
          "years": [
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017"
            ],
            "window_lifter": [
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023"
            ],
            "sunshade": [
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter",
            "sunshade"
          ],
          "coverageKey": "toyota__kamry",
          "displayName": "טויוטה קאמרי"
        },
        {
          "label": "קורולה",
          "value": "kvrvlh",
          "years": [
            "2000",
            "2001",
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023"
            ],
            "window_lifter": [
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023"
            ],
            "sunshade": [
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter",
            "sunshade",
            "floor_mats"
          ],
          "coverageKey": "toyota__kvrvlh",
          "displayName": "טויוטה קורולה"
        },
        {
          "label": "קורולה קרוס",
          "value": "corolla_cross",
          "years": [
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2025"
            ],
            "window_lifter": [
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "toyota__corolla_cross",
          "displayName": "טויוטה קורולה קרוס"
        }
      ]
    },
    {
      "label": "טסלה",
      "value": "tesla",
      "types": [
        "floor_mats"
      ],
      "models": [
        {
          "label": "מודל 3",
          "value": "mvdl-3",
          "years": [
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "floor_mats"
          ],
          "coverageKey": "tesla__mvdl-3",
          "displayName": "טסלה מודל 3"
        }
      ]
    },
    {
      "label": "יגואר",
      "value": "jaguar",
      "types": [
        "window_lifter"
      ],
      "models": [
        {
          "label": "יגואר F-Pace",
          "value": "jaguar_f_pace",
          "years": [
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "jaguar__jaguar_f_pace",
          "displayName": "יגואר יגואר F-Pace"
        }
      ]
    },
    {
      "label": "יונדאי",
      "value": "hyundai",
      "types": [
        "multimedia",
        "window_lifter",
        "sunshade",
        "floor_mats"
      ],
      "models": [
        {
          "label": "H1",
          "value": "h1",
          "years": [
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020"
          ],
          "yearsByType": {
            "all": [
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020"
            ],
            "multimedia": [
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020"
            ]
          },
          "productTypes": [
            "multimedia"
          ],
          "coverageKey": "hyundai__h1",
          "displayName": "יונדאי H1"
        },
        {
          "label": "i10",
          "value": "i10",
          "years": [
            "1999",
            "2000",
            "2001",
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018"
            ],
            "window_lifter": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter",
            "floor_mats"
          ],
          "coverageKey": "hyundai__i10",
          "displayName": "יונדאי i10"
        },
        {
          "label": "i20",
          "value": "i20",
          "years": [
            "1999",
            "2000",
            "2001",
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019"
            ],
            "window_lifter": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "sunshade": [
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter",
            "sunshade",
            "floor_mats"
          ],
          "coverageKey": "hyundai__i20",
          "displayName": "יונדאי i20"
        },
        {
          "label": "i25",
          "value": "i25",
          "years": [
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017"
          ],
          "yearsByType": {
            "all": [
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017"
            ],
            "multimedia": [
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017"
            ]
          },
          "productTypes": [
            "multimedia"
          ],
          "coverageKey": "hyundai__i25",
          "displayName": "יונדאי i25"
        },
        {
          "label": "i30",
          "value": "i30",
          "years": [
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017"
            ],
            "floor_mats": [
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "floor_mats"
          ],
          "coverageKey": "hyundai__i30",
          "displayName": "יונדאי i30"
        },
        {
          "label": "i40",
          "value": "i40",
          "years": [
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016"
          ],
          "yearsByType": {
            "all": [
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016"
            ],
            "multimedia": [
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016"
            ]
          },
          "productTypes": [
            "multimedia"
          ],
          "coverageKey": "hyundai__i40",
          "displayName": "יונדאי i40"
        },
        {
          "label": "ix35",
          "value": "ix35",
          "years": [
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019"
          ],
          "yearsByType": {
            "all": [
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019"
            ],
            "multimedia": [
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019"
            ]
          },
          "productTypes": [
            "multimedia"
          ],
          "coverageKey": "hyundai__ix35",
          "displayName": "יונדאי ix35"
        },
        {
          "label": "איוניק",
          "value": "ayvnyk",
          "years": [
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023"
            ],
            "window_lifter": [
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022"
            ],
            "sunshade": [
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter",
            "sunshade"
          ],
          "coverageKey": "hyundai__ayvnyk",
          "displayName": "יונדאי איוניק"
        },
        {
          "label": "איוניק 5",
          "value": "ayvnyk-5",
          "years": [
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "sunshade": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter",
            "sunshade",
            "floor_mats"
          ],
          "coverageKey": "hyundai__ayvnyk-5",
          "displayName": "יונדאי איוניק 5"
        },
        {
          "label": "איוניק 6",
          "value": "ioniq_6",
          "years": [
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "hyundai__ioniq_6",
          "displayName": "יונדאי איוניק 6"
        },
        {
          "label": "אלנטרה",
          "value": "alntrh",
          "years": [
            "1999",
            "2000",
            "2001",
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020"
            ],
            "window_lifter": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "sunshade": [
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter",
            "sunshade",
            "floor_mats"
          ],
          "coverageKey": "hyundai__alntrh",
          "displayName": "יונדאי אלנטרה"
        },
        {
          "label": "אקסנט",
          "value": "aksnt",
          "years": [
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023"
          ],
          "yearsByType": {
            "all": [
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023"
            ],
            "multimedia": [
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020"
            ],
            "window_lifter": [
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023"
            ],
            "floor_mats": [
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter",
            "floor_mats"
          ],
          "coverageKey": "hyundai__aksnt",
          "displayName": "יונדאי אקסנט"
        },
        {
          "label": "באיון",
          "value": "bayvn",
          "years": [
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "sunshade": [
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter",
            "sunshade"
          ],
          "coverageKey": "hyundai__bayvn",
          "displayName": "יונדאי באיון"
        },
        {
          "label": "וולוסטר",
          "value": "vvlvstr",
          "years": [
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018"
          ],
          "yearsByType": {
            "all": [
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018"
            ],
            "multimedia": [
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018"
            ]
          },
          "productTypes": [
            "multimedia"
          ],
          "coverageKey": "hyundai__vvlvstr",
          "displayName": "יונדאי וולוסטר"
        },
        {
          "label": "ווניו",
          "value": "vnyv",
          "years": [
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "sunshade": [
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter",
            "sunshade"
          ],
          "coverageKey": "hyundai__vnyv",
          "displayName": "יונדאי ווניו"
        },
        {
          "label": "טוסון",
          "value": "tvsvn",
          "years": [
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019"
            ],
            "window_lifter": [
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "sunshade": [
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter",
            "sunshade",
            "floor_mats"
          ],
          "coverageKey": "hyundai__tvsvn",
          "displayName": "יונדאי טוסון"
        },
        {
          "label": "סונטה",
          "value": "svnth",
          "years": [
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2017",
              "2018",
              "2019"
            ],
            "window_lifter": [
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "sunshade": [
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024"
            ],
            "floor_mats": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter",
            "sunshade",
            "floor_mats"
          ],
          "coverageKey": "hyundai__svnth",
          "displayName": "יונדאי סונטה"
        },
        {
          "label": "סטאריה",
          "value": "staria",
          "years": [
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "hyundai__staria",
          "displayName": "יונדאי סטאריה"
        },
        {
          "label": "סנטפה",
          "value": "sntph",
          "years": [
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024"
            ],
            "floor_mats": [
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter",
            "floor_mats"
          ],
          "coverageKey": "hyundai__sntph",
          "displayName": "יונדאי סנטפה"
        },
        {
          "label": "פלסייד",
          "value": "palisade",
          "years": [
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "hyundai__palisade",
          "displayName": "יונדאי פלסייד"
        },
        {
          "label": "קונה",
          "value": "kvnh",
          "years": [
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2017",
              "2018",
              "2019",
              "2020"
            ],
            "window_lifter": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "sunshade": [
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter",
            "sunshade",
            "floor_mats"
          ],
          "coverageKey": "hyundai__kvnh",
          "displayName": "יונדאי קונה"
        }
      ]
    },
    {
      "label": "לנד רובר",
      "value": "land_rover",
      "types": [
        "window_lifter"
      ],
      "models": [
        {
          "label": "איווק",
          "value": "evoque",
          "years": [
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "land_rover__evoque",
          "displayName": "לנד רובר איווק"
        },
        {
          "label": "דיסקברי",
          "value": "discovery",
          "years": [
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "land_rover__discovery",
          "displayName": "לנד רובר דיסקברי"
        },
        {
          "label": "וילאר",
          "value": "velar",
          "years": [
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "land_rover__velar",
          "displayName": "לנד רובר וילאר"
        },
        {
          "label": "ריינרובר",
          "value": "range_rover",
          "years": [
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "land_rover__range_rover",
          "displayName": "לנד רובר ריינרובר"
        }
      ]
    },
    {
      "label": "לקסוס",
      "value": "lexus",
      "types": [
        "window_lifter"
      ],
      "models": [
        {
          "label": "GS",
          "value": "gs",
          "years": [
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "lexus__gs",
          "displayName": "לקסוס GS"
        },
        {
          "label": "IS",
          "value": "is",
          "years": [
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "lexus__is",
          "displayName": "לקסוס IS"
        },
        {
          "label": "NX",
          "value": "nx",
          "years": [
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "lexus__nx",
          "displayName": "לקסוס NX"
        },
        {
          "label": "RX",
          "value": "rx",
          "years": [
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "lexus__rx",
          "displayName": "לקסוס RX"
        }
      ]
    },
    {
      "label": "מאזדה",
      "value": "mazda",
      "types": [
        "multimedia",
        "window_lifter",
        "sunshade",
        "floor_mats"
      ],
      "models": [
        {
          "label": "CX-3",
          "value": "cx3",
          "years": [
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "sunshade": [
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022"
            ],
            "floor_mats": [
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter",
            "sunshade",
            "floor_mats"
          ],
          "coverageKey": "mazda__cx3",
          "displayName": "מאזדה CX-3"
        },
        {
          "label": "CX-30",
          "value": "cx-30",
          "years": [
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "mazda__cx-30",
          "displayName": "מאזדה CX-30"
        },
        {
          "label": "CX-5",
          "value": "cx5",
          "years": [
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "sunshade": [
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter",
            "sunshade",
            "floor_mats"
          ],
          "coverageKey": "mazda__cx5",
          "displayName": "מאזדה CX-5"
        },
        {
          "label": "CX-90",
          "value": "cx_90",
          "years": [
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "mazda__cx_90",
          "displayName": "מאזדה CX-90"
        },
        {
          "label": "MPV",
          "value": "mpv",
          "years": [
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016"
          ],
          "yearsByType": {
            "all": [
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016"
            ],
            "multimedia": [
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016"
            ]
          },
          "productTypes": [
            "multimedia"
          ],
          "coverageKey": "mazda__mpv",
          "displayName": "מאזדה MPV"
        },
        {
          "label": "דמיו",
          "value": "dmyv",
          "years": [
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021"
          ],
          "yearsByType": {
            "all": [
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021"
            ],
            "multimedia": [
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021"
            ]
          },
          "productTypes": [
            "multimedia"
          ],
          "coverageKey": "mazda__dmyv",
          "displayName": "מאזדה דמיו"
        },
        {
          "label": "מאזדה 2",
          "value": "mazda2",
          "years": [
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021"
            ],
            "window_lifter": [
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter"
          ],
          "coverageKey": "mazda__mazda2",
          "displayName": "מאזדה מאזדה 2"
        },
        {
          "label": "מאזדה 3",
          "value": "mazda3",
          "years": [
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2025"
            ],
            "multimedia": [
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023"
            ],
            "window_lifter": [
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2025"
            ],
            "floor_mats": [
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter",
            "floor_mats"
          ],
          "coverageKey": "mazda__mazda3",
          "displayName": "מאזדה מאזדה 3"
        },
        {
          "label": "מאזדה 5",
          "value": "mazdh-5",
          "years": [
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015"
          ],
          "yearsByType": {
            "all": [
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015"
            ],
            "multimedia": [
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015"
            ]
          },
          "productTypes": [
            "multimedia"
          ],
          "coverageKey": "mazda__mazdh-5",
          "displayName": "מאזדה מאזדה 5"
        },
        {
          "label": "מאזדה 6",
          "value": "mazda6",
          "years": [
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023"
            ],
            "window_lifter": [
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2012",
              "2013",
              "2014",
              "2015",
              "2016"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter",
            "floor_mats"
          ],
          "coverageKey": "mazda__mazda6",
          "displayName": "מאזדה מאזדה 6"
        },
        {
          "label": "מיאטה\nMX5",
          "value": "myathmx5",
          "years": [
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014"
          ],
          "yearsByType": {
            "all": [
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014"
            ],
            "multimedia": [
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014"
            ]
          },
          "productTypes": [
            "multimedia"
          ],
          "coverageKey": "mazda__myathmx5",
          "displayName": "מאזדה מיאטה\nMX5"
        }
      ]
    },
    {
      "label": "מיני",
      "value": "mini",
      "types": [
        "window_lifter"
      ],
      "models": [
        {
          "label": "מיני קופר",
          "value": "mini_cooper",
          "years": [
            "1999",
            "2000",
            "2001",
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "mini__mini_cooper",
          "displayName": "מיני מיני קופר"
        }
      ]
    },
    {
      "label": "מיצובישי",
      "value": "mitsubishi",
      "types": [
        "multimedia",
        "window_lifter",
        "sunshade",
        "floor_mats"
      ],
      "models": [
        {
          "label": "ASX",
          "value": "asx",
          "years": [
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022"
            ],
            "window_lifter": [
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "sunshade": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter",
            "sunshade"
          ],
          "coverageKey": "mitsubishi__asx",
          "displayName": "מיצובישי ASX"
        },
        {
          "label": "L200",
          "value": "l200",
          "years": [
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023"
          ],
          "yearsByType": {
            "all": [
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023"
            ],
            "multimedia": [
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023"
            ]
          },
          "productTypes": [
            "multimedia"
          ],
          "coverageKey": "mitsubishi__l200",
          "displayName": "מיצובישי L200"
        },
        {
          "label": "אאוטלנדר",
          "value": "outlander",
          "years": [
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021"
            ],
            "window_lifter": [
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "sunshade": [
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter",
            "sunshade",
            "floor_mats"
          ],
          "coverageKey": "mitsubishi__outlander",
          "displayName": "מיצובישי אאוטלנדר"
        },
        {
          "label": "אטרג",
          "value": "atrg",
          "years": [
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019"
          ],
          "yearsByType": {
            "all": [
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019"
            ],
            "multimedia": [
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019"
            ]
          },
          "productTypes": [
            "multimedia"
          ],
          "coverageKey": "mitsubishi__atrg",
          "displayName": "מיצובישי אטרג"
        },
        {
          "label": "אקליפס",
          "value": "aklyps",
          "years": [
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter",
            "floor_mats"
          ],
          "coverageKey": "mitsubishi__aklyps",
          "displayName": "מיצובישי אקליפס"
        },
        {
          "label": "אקליפס קרוס",
          "value": "aklyps-krvs",
          "years": [
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "sunshade": [
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "sunshade"
          ],
          "coverageKey": "mitsubishi__aklyps-krvs",
          "displayName": "מיצובישי אקליפס קרוס"
        },
        {
          "label": "גרנדיס",
          "value": "grndys",
          "years": [
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011"
          ],
          "yearsByType": {
            "all": [
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011"
            ],
            "multimedia": [
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011"
            ]
          },
          "productTypes": [
            "multimedia"
          ],
          "coverageKey": "mitsubishi__grndys",
          "displayName": "מיצובישי גרנדיס"
        },
        {
          "label": "טריטון",
          "value": "trytvn",
          "years": [
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023"
            ],
            "window_lifter": [
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter"
          ],
          "coverageKey": "mitsubishi__trytvn",
          "displayName": "מיצובישי טריטון"
        },
        {
          "label": "לנסר",
          "value": "lnsr",
          "years": [
            "2000",
            "2001",
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017"
          ],
          "yearsByType": {
            "all": [
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017"
            ],
            "multimedia": [
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016"
            ],
            "window_lifter": [
              "2016",
              "2017"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter"
          ],
          "coverageKey": "mitsubishi__lnsr",
          "displayName": "מיצובישי לנסר"
        },
        {
          "label": "ספייס סטאר",
          "value": "space-star",
          "years": [
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019"
            ],
            "window_lifter": [
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter"
          ],
          "coverageKey": "mitsubishi__space-star",
          "displayName": "מיצובישי ספייס סטאר"
        },
        {
          "label": "פאג׳רו",
          "value": "pajero",
          "years": [
            "1999",
            "2000",
            "2001",
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024"
          ],
          "yearsByType": {
            "all": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024"
            ],
            "multimedia": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024"
            ],
            "window_lifter": [
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter"
          ],
          "coverageKey": "mitsubishi__pajero",
          "displayName": "מיצובישי פאג׳רו"
        }
      ]
    },
    {
      "label": "מרצדס",
      "value": "mercedes",
      "types": [
        "window_lifter",
        "sunshade",
        "floor_mats"
      ],
      "models": [
        {
          "label": "A-Class",
          "value": "a_class",
          "years": [
            "1999",
            "2000",
            "2001",
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "mercedes__a_class",
          "displayName": "מרצדס A-Class"
        },
        {
          "label": "B-Class",
          "value": "b_class",
          "years": [
            "1999",
            "2000",
            "2001",
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "mercedes__b_class",
          "displayName": "מרצדס B-Class"
        },
        {
          "label": "C-Class",
          "value": "c-class",
          "years": [
            "1999",
            "2000",
            "2001",
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "sunshade": [
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021"
            ],
            "floor_mats": [
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter",
            "sunshade",
            "floor_mats"
          ],
          "coverageKey": "mercedes__c-class",
          "displayName": "מרצדס C-Class"
        },
        {
          "label": "CLA",
          "value": "cla",
          "years": [
            "1999",
            "2000",
            "2001",
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "mercedes__cla",
          "displayName": "מרצדס CLA"
        },
        {
          "label": "CLS",
          "value": "cls",
          "years": [
            "1999",
            "2000",
            "2001",
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "mercedes__cls",
          "displayName": "מרצדס CLS"
        },
        {
          "label": "E-Class",
          "value": "e-class",
          "years": [
            "1999",
            "2000",
            "2001",
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "sunshade": [
              "2016",
              "2017",
              "2018",
              "2019",
              "2020"
            ],
            "floor_mats": [
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter",
            "sunshade",
            "floor_mats"
          ],
          "coverageKey": "mercedes__e-class",
          "displayName": "מרצדס E-Class"
        },
        {
          "label": "GL",
          "value": "gl",
          "years": [
            "1999",
            "2000",
            "2001",
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "mercedes__gl",
          "displayName": "מרצדס GL"
        },
        {
          "label": "GLA",
          "value": "gla",
          "years": [
            "1999",
            "2000",
            "2001",
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "mercedes__gla",
          "displayName": "מרצדס GLA"
        },
        {
          "label": "GLC",
          "value": "glc",
          "years": [
            "1999",
            "2000",
            "2001",
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "mercedes__glc",
          "displayName": "מרצדס GLC"
        },
        {
          "label": "GLE",
          "value": "gle",
          "years": [
            "1999",
            "2000",
            "2001",
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "mercedes__gle",
          "displayName": "מרצדס GLE"
        },
        {
          "label": "GLK",
          "value": "glk",
          "years": [
            "1999",
            "2000",
            "2001",
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "mercedes__glk",
          "displayName": "מרצדס GLK"
        },
        {
          "label": "GLS",
          "value": "gls",
          "years": [
            "1999",
            "2000",
            "2001",
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "mercedes__gls",
          "displayName": "מרצדס GLS"
        },
        {
          "label": "ML",
          "value": "ml",
          "years": [
            "1999",
            "2000",
            "2001",
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "mercedes__ml",
          "displayName": "מרצדס ML"
        },
        {
          "label": "Sprinter",
          "value": "sprinter",
          "years": [
            "1999",
            "2000",
            "2001",
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "mercedes__sprinter",
          "displayName": "מרצדס Sprinter"
        },
        {
          "label": "Vito",
          "value": "vito",
          "years": [
            "1999",
            "2000",
            "2001",
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "mercedes__vito",
          "displayName": "מרצדס Vito"
        }
      ]
    },
    {
      "label": "ניסאן",
      "value": "nissan",
      "types": [
        "multimedia",
        "window_lifter",
        "sunshade",
        "floor_mats"
      ],
      "models": [
        {
          "label": "NV200",
          "value": "nv200",
          "years": [
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019"
          ],
          "yearsByType": {
            "all": [
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019"
            ],
            "multimedia": [
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019"
            ]
          },
          "productTypes": [
            "multimedia"
          ],
          "coverageKey": "nissan__nv200",
          "displayName": "ניסאן NV200"
        },
        {
          "label": "X-Trail",
          "value": "x-trail",
          "years": [
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022"
            ],
            "window_lifter": [
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "sunshade": [
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter",
            "sunshade",
            "floor_mats"
          ],
          "coverageKey": "nissan__x-trail",
          "displayName": "ניסאן X-Trail"
        },
        {
          "label": "אלטימה",
          "value": "altymh",
          "years": [
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018"
          ],
          "yearsByType": {
            "all": [
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018"
            ],
            "multimedia": [
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018"
            ]
          },
          "productTypes": [
            "multimedia"
          ],
          "coverageKey": "nissan__altymh",
          "displayName": "ניסאן אלטימה"
        },
        {
          "label": "גוק",
          "value": "juke",
          "years": [
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "nissan__juke",
          "displayName": "ניסאן גוק"
        },
        {
          "label": "ג׳וק",
          "value": "gvk",
          "years": [
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016"
            ],
            "sunshade": [
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "sunshade",
            "floor_mats"
          ],
          "coverageKey": "nissan__gvk",
          "displayName": "ניסאן ג׳וק"
        },
        {
          "label": "טידה",
          "value": "tiida",
          "years": [
            "2009",
            "2010",
            "2011",
            "2012"
          ],
          "yearsByType": {
            "all": [
              "2009",
              "2010",
              "2011",
              "2012"
            ],
            "window_lifter": [
              "2009",
              "2010",
              "2011",
              "2012"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "nissan__tiida",
          "displayName": "ניסאן טידה"
        },
        {
          "label": "מיקרה",
          "value": "micra",
          "years": [
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020"
          ],
          "yearsByType": {
            "all": [
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020"
            ],
            "multimedia": [
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017"
            ],
            "window_lifter": [
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter"
          ],
          "coverageKey": "nissan__micra",
          "displayName": "ניסאן מיקרה"
        },
        {
          "label": "מקסימה",
          "value": "mksymh",
          "years": [
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020"
          ],
          "yearsByType": {
            "all": [
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020"
            ],
            "multimedia": [
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020"
            ]
          },
          "productTypes": [
            "multimedia"
          ],
          "coverageKey": "nissan__mksymh",
          "displayName": "ניסאן מקסימה"
        },
        {
          "label": "נאברה",
          "value": "navara",
          "years": [
            "2018",
            "2019",
            "2020",
            "2021"
          ],
          "yearsByType": {
            "all": [
              "2018",
              "2019",
              "2020",
              "2021"
            ],
            "window_lifter": [
              "2018",
              "2019",
              "2020",
              "2021"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "nissan__navara",
          "displayName": "ניסאן נאברה"
        },
        {
          "label": "נבארה",
          "value": "nbarh",
          "years": [
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021"
          ],
          "yearsByType": {
            "all": [
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021"
            ],
            "multimedia": [
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021"
            ]
          },
          "productTypes": [
            "multimedia"
          ],
          "coverageKey": "nissan__nbarh",
          "displayName": "ניסאן נבארה"
        },
        {
          "label": "נוט",
          "value": "nvt",
          "years": [
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019"
          ],
          "yearsByType": {
            "all": [
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019"
            ],
            "multimedia": [
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019"
            ]
          },
          "productTypes": [
            "multimedia"
          ],
          "coverageKey": "nissan__nvt",
          "displayName": "ניסאן נוט"
        },
        {
          "label": "סנטרה",
          "value": "sntrh",
          "years": [
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017"
            ],
            "window_lifter": [
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter"
          ],
          "coverageKey": "nissan__sntrh",
          "displayName": "ניסאן סנטרה"
        },
        {
          "label": "פטרול",
          "value": "ptrvl",
          "years": [
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020"
          ],
          "yearsByType": {
            "all": [
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020"
            ],
            "multimedia": [
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020"
            ]
          },
          "productTypes": [
            "multimedia"
          ],
          "coverageKey": "nissan__ptrvl",
          "displayName": "ניסאן פטרול"
        },
        {
          "label": "קשקאי",
          "value": "qashqai",
          "years": [
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022"
            ],
            "window_lifter": [
              "2009",
              "2010",
              "2011",
              "2012",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter",
            "floor_mats"
          ],
          "coverageKey": "nissan__qashqai",
          "displayName": "ניסאן קשקאי"
        }
      ]
    },
    {
      "label": "סאנגיונג",
      "value": "ssangyong",
      "types": [
        "window_lifter"
      ],
      "models": [
        {
          "label": "רקסטון",
          "value": "rexton",
          "years": [
            "1999",
            "2000",
            "2001",
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "ssangyong__rexton",
          "displayName": "סאנגיונג רקסטון"
        }
      ]
    },
    {
      "label": "סובארו",
      "value": "subaru",
      "types": [
        "multimedia",
        "window_lifter",
        "sunshade",
        "floor_mats"
      ],
      "models": [
        {
          "label": "WRX",
          "value": "wrx",
          "years": [
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018"
          ],
          "yearsByType": {
            "all": [
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018"
            ],
            "multimedia": [
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018"
            ]
          },
          "productTypes": [
            "multimedia"
          ],
          "coverageKey": "subaru__wrx",
          "displayName": "סובארו WRX"
        },
        {
          "label": "XV",
          "value": "xv",
          "years": [
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023"
            ],
            "window_lifter": [
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "sunshade": [
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter",
            "sunshade",
            "floor_mats"
          ],
          "coverageKey": "subaru__xv",
          "displayName": "סובארו XV"
        },
        {
          "label": "אאוטבק",
          "value": "outback",
          "years": [
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018"
            ],
            "window_lifter": [
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter"
          ],
          "coverageKey": "subaru__outback",
          "displayName": "סובארו אאוטבק"
        },
        {
          "label": "אימפרזה",
          "value": "impreza",
          "years": [
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023"
          ],
          "yearsByType": {
            "all": [
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023"
            ],
            "multimedia": [
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023"
            ],
            "window_lifter": [
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter"
          ],
          "coverageKey": "subaru__impreza",
          "displayName": "סובארו אימפרזה"
        },
        {
          "label": "לגסי",
          "value": "lgsy",
          "years": [
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018"
          ],
          "yearsByType": {
            "all": [
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018"
            ],
            "multimedia": [
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018"
            ]
          },
          "productTypes": [
            "multimedia"
          ],
          "coverageKey": "subaru__lgsy",
          "displayName": "סובארו לגסי"
        },
        {
          "label": "פורסטר",
          "value": "forester",
          "years": [
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021"
            ],
            "window_lifter": [
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter",
            "floor_mats"
          ],
          "coverageKey": "subaru__forester",
          "displayName": "סובארו פורסטר"
        },
        {
          "label": "קרוסטרק",
          "value": "crosstrek",
          "years": [
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "subaru__crosstrek",
          "displayName": "סובארו קרוסטרק"
        }
      ]
    },
    {
      "label": "סוזוקי",
      "value": "suzuki",
      "types": [
        "multimedia",
        "window_lifter",
        "sunshade",
        "floor_mats"
      ],
      "models": [
        {
          "label": "S-Cross",
          "value": "s-cross",
          "years": [
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2012",
              "2013",
              "2014",
              "2015",
              "2016"
            ],
            "window_lifter": [
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter"
          ],
          "coverageKey": "suzuki__s-cross",
          "displayName": "סוזוקי S-Cross"
        },
        {
          "label": "SX4",
          "value": "sx4",
          "years": [
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016"
            ],
            "window_lifter": [
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter",
            "floor_mats"
          ],
          "coverageKey": "suzuki__sx4",
          "displayName": "סוזוקי SX4"
        },
        {
          "label": "איגניס",
          "value": "aygnys",
          "years": [
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2016",
              "2017",
              "2018",
              "2019",
              "2020"
            ],
            "window_lifter": [
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter"
          ],
          "coverageKey": "suzuki__aygnys",
          "displayName": "סוזוקי איגניס"
        },
        {
          "label": "אלטו",
          "value": "altv",
          "years": [
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016"
          ],
          "yearsByType": {
            "all": [
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016"
            ],
            "multimedia": [
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016"
            ]
          },
          "productTypes": [
            "multimedia"
          ],
          "coverageKey": "suzuki__altv",
          "displayName": "סוזוקי אלטו"
        },
        {
          "label": "באלנו",
          "value": "baleno",
          "years": [
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2015",
              "2016",
              "2017",
              "2018",
              "2019"
            ],
            "window_lifter": [
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter"
          ],
          "coverageKey": "suzuki__baleno",
          "displayName": "סוזוקי באלנו"
        },
        {
          "label": "גרנד ויטרה",
          "value": "grnd-vytrh",
          "years": [
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021"
          ],
          "yearsByType": {
            "all": [
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021"
            ],
            "multimedia": [
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019"
            ],
            "sunshade": [
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021"
            ]
          },
          "productTypes": [
            "multimedia",
            "sunshade"
          ],
          "coverageKey": "suzuki__grnd-vytrh",
          "displayName": "סוזוקי גרנד ויטרה"
        },
        {
          "label": "ג׳ימני",
          "value": "gymny",
          "years": [
            "2000",
            "2001",
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023"
            ],
            "window_lifter": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "sunshade": [
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter",
            "sunshade",
            "floor_mats"
          ],
          "coverageKey": "suzuki__gymny",
          "displayName": "סוזוקי ג׳ימני"
        },
        {
          "label": "ויטרה",
          "value": "vytrh",
          "years": [
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022"
            ],
            "window_lifter": [
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "sunshade": [
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter",
            "sunshade",
            "floor_mats"
          ],
          "coverageKey": "suzuki__vytrh",
          "displayName": "סוזוקי ויטרה"
        },
        {
          "label": "סוויפט",
          "value": "svvypt",
          "years": [
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020"
            ],
            "window_lifter": [
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter"
          ],
          "coverageKey": "suzuki__svvypt",
          "displayName": "סוזוקי סוויפט"
        },
        {
          "label": "סלריו",
          "value": "slryv",
          "years": [
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2015",
              "2016",
              "2017",
              "2018"
            ],
            "window_lifter": [
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter"
          ],
          "coverageKey": "suzuki__slryv",
          "displayName": "סוזוקי סלריו"
        },
        {
          "label": "ספלאש",
          "value": "splash",
          "years": [
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014"
          ],
          "yearsByType": {
            "all": [
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014"
            ],
            "multimedia": [
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014"
            ]
          },
          "productTypes": [
            "multimedia"
          ],
          "coverageKey": "suzuki__splash",
          "displayName": "סוזוקי ספלאש"
        }
      ]
    },
    {
      "label": "סיאט",
      "value": "seat",
      "types": [
        "window_lifter",
        "sunshade",
        "floor_mats"
      ],
      "models": [
        {
          "label": "אטקה",
          "value": "atkh",
          "years": [
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "sunshade": [
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "sunshade",
            "floor_mats"
          ],
          "coverageKey": "seat__atkh",
          "displayName": "סיאט אטקה"
        },
        {
          "label": "איביזה",
          "value": "aybyzh",
          "years": [
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter",
            "floor_mats"
          ],
          "coverageKey": "seat__aybyzh",
          "displayName": "סיאט איביזה"
        },
        {
          "label": "ארונה",
          "value": "arvnh",
          "years": [
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter",
            "floor_mats"
          ],
          "coverageKey": "seat__arvnh",
          "displayName": "סיאט ארונה"
        },
        {
          "label": "טולדו",
          "value": "tvldv",
          "years": [
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020"
          ],
          "yearsByType": {
            "all": [
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020"
            ],
            "floor_mats": [
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020"
            ]
          },
          "productTypes": [
            "floor_mats"
          ],
          "coverageKey": "seat__tvldv",
          "displayName": "סיאט טולדו"
        }
      ]
    },
    {
      "label": "סיטרואן",
      "value": "citroen",
      "types": [
        "window_lifter",
        "floor_mats"
      ],
      "models": [
        {
          "label": "C3",
          "value": "c3",
          "years": [
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "citroen__c3",
          "displayName": "סיטרואן C3"
        },
        {
          "label": "C4",
          "value": "c4",
          "years": [
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "citroen__c4",
          "displayName": "סיטרואן C4"
        },
        {
          "label": "c4 פיקאסו",
          "value": "c4-pykasv",
          "years": [
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018"
          ],
          "yearsByType": {
            "all": [
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018"
            ],
            "floor_mats": [
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018"
            ]
          },
          "productTypes": [
            "floor_mats"
          ],
          "coverageKey": "citroen__c4-pykasv",
          "displayName": "סיטרואן c4 פיקאסו"
        },
        {
          "label": "C5",
          "value": "c5",
          "years": [
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "citroen__c5",
          "displayName": "סיטרואן C5"
        },
        {
          "label": "ברלינגו",
          "value": "brlyngv",
          "years": [
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024"
            ]
          },
          "productTypes": [
            "window_lifter",
            "floor_mats"
          ],
          "coverageKey": "citroen__brlyngv",
          "displayName": "סיטרואן ברלינגו"
        },
        {
          "label": "גמפי",
          "value": "jumpy",
          "years": [
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "citroen__jumpy",
          "displayName": "סיטרואן גמפי"
        }
      ]
    },
    {
      "label": "סקודה",
      "value": "skoda",
      "types": [
        "window_lifter",
        "sunshade",
        "floor_mats"
      ],
      "models": [
        {
          "label": "אוקטביה",
          "value": "avktbyh",
          "years": [
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "sunshade": [
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024"
            ],
            "floor_mats": [
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter",
            "sunshade",
            "floor_mats"
          ],
          "coverageKey": "skoda__avktbyh",
          "displayName": "סקודה אוקטביה"
        },
        {
          "label": "אניאק",
          "value": "anyak",
          "years": [
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "sunshade": [
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "sunshade",
            "floor_mats"
          ],
          "coverageKey": "skoda__anyak",
          "displayName": "סקודה אניאק"
        },
        {
          "label": "ייטי",
          "value": "yyty",
          "years": [
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017"
          ],
          "yearsByType": {
            "all": [
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017"
            ],
            "floor_mats": [
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017"
            ]
          },
          "productTypes": [
            "floor_mats"
          ],
          "coverageKey": "skoda__yyty",
          "displayName": "סקודה ייטי"
        },
        {
          "label": "סופרב",
          "value": "svprb",
          "years": [
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "sunshade": [
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "sunshade",
            "floor_mats"
          ],
          "coverageKey": "skoda__svprb",
          "displayName": "סקודה סופרב"
        },
        {
          "label": "סקאלה",
          "value": "skalh",
          "years": [
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "floor_mats"
          ],
          "coverageKey": "skoda__skalh",
          "displayName": "סקודה סקאלה"
        },
        {
          "label": "פאביה",
          "value": "pabyh",
          "years": [
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021"
          ],
          "yearsByType": {
            "all": [
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021"
            ],
            "floor_mats": [
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021"
            ]
          },
          "productTypes": [
            "floor_mats"
          ],
          "coverageKey": "skoda__pabyh",
          "displayName": "סקודה פאביה"
        },
        {
          "label": "קאמיק",
          "value": "kamyk",
          "years": [
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "sunshade": [
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "sunshade",
            "floor_mats"
          ],
          "coverageKey": "skoda__kamyk",
          "displayName": "סקודה קאמיק"
        },
        {
          "label": "קארוק",
          "value": "karvk",
          "years": [
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "sunshade": [
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "sunshade",
            "floor_mats"
          ],
          "coverageKey": "skoda__karvk",
          "displayName": "סקודה קארוק"
        },
        {
          "label": "קודיאק",
          "value": "kvdyak",
          "years": [
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "sunshade": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024"
            ],
            "floor_mats": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter",
            "sunshade",
            "floor_mats"
          ],
          "coverageKey": "skoda__kvdyak",
          "displayName": "סקודה קודיאק"
        },
        {
          "label": "ראפיד",
          "value": "rapyd",
          "years": [
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "floor_mats"
          ],
          "coverageKey": "skoda__rapyd",
          "displayName": "סקודה ראפיד"
        }
      ]
    },
    {
      "label": "פולסווגן",
      "value": "volkswagen",
      "types": [
        "window_lifter",
        "sunshade",
        "floor_mats"
      ],
      "models": [
        {
          "label": "ID4",
          "value": "id4",
          "years": [
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "volkswagen__id4",
          "displayName": "פולסווגן ID4"
        },
        {
          "label": "ID5",
          "value": "id5",
          "years": [
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "volkswagen__id5",
          "displayName": "פולסווגן ID5"
        },
        {
          "label": "גולף",
          "value": "gvlp",
          "years": [
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019"
          ],
          "yearsByType": {
            "all": [
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019"
            ],
            "sunshade": [
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009"
            ],
            "floor_mats": [
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019"
            ]
          },
          "productTypes": [
            "sunshade",
            "floor_mats"
          ],
          "coverageKey": "volkswagen__gvlp",
          "displayName": "פולסווגן גולף"
        },
        {
          "label": "פאסאט",
          "value": "pasat",
          "years": [
            "2016",
            "2017",
            "2018",
            "2019"
          ],
          "yearsByType": {
            "all": [
              "2016",
              "2017",
              "2018",
              "2019"
            ],
            "sunshade": [
              "2016",
              "2017",
              "2018",
              "2019"
            ]
          },
          "productTypes": [
            "sunshade"
          ],
          "coverageKey": "volkswagen__pasat",
          "displayName": "פולסווגן פאסאט"
        }
      ]
    },
    {
      "label": "פורד",
      "value": "ford",
      "types": [
        "multimedia",
        "window_lifter",
        "floor_mats"
      ],
      "models": [
        {
          "label": "s-max",
          "value": "s-max",
          "years": [
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015"
          ],
          "yearsByType": {
            "all": [
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015"
            ],
            "multimedia": [
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015"
            ]
          },
          "productTypes": [
            "multimedia"
          ],
          "coverageKey": "ford__s-max",
          "displayName": "פורד s-max"
        },
        {
          "label": "אדג'",
          "value": "adg",
          "years": [
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018"
          ],
          "yearsByType": {
            "all": [
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018"
            ],
            "multimedia": [
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018"
            ]
          },
          "productTypes": [
            "multimedia"
          ],
          "coverageKey": "ford__adg",
          "displayName": "פורד אדג'"
        },
        {
          "label": "גלקסי",
          "value": "glksy",
          "years": [
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015"
          ],
          "yearsByType": {
            "all": [
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015"
            ],
            "multimedia": [
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015"
            ]
          },
          "productTypes": [
            "multimedia"
          ],
          "coverageKey": "ford__glksy",
          "displayName": "פורד גלקסי"
        },
        {
          "label": "טרנזיט",
          "value": "trnzyt",
          "years": [
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018"
          ],
          "yearsByType": {
            "all": [
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018"
            ],
            "multimedia": [
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018"
            ]
          },
          "productTypes": [
            "multimedia"
          ],
          "coverageKey": "ford__trnzyt",
          "displayName": "פורד טרנזיט"
        },
        {
          "label": "מונדאו",
          "value": "mvndav",
          "years": [
            "2000",
            "2001",
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019"
          ],
          "yearsByType": {
            "all": [
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019"
            ],
            "multimedia": [
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019"
            ]
          },
          "productTypes": [
            "multimedia"
          ],
          "coverageKey": "ford__mvndav",
          "displayName": "פורד מונדאו"
        },
        {
          "label": "מוסטנג",
          "value": "mustang",
          "years": [
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "ford__mustang",
          "displayName": "פורד מוסטנג"
        },
        {
          "label": "פומה",
          "value": "pvmh",
          "years": [
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "floor_mats"
          ],
          "coverageKey": "ford__pvmh",
          "displayName": "פורד פומה"
        },
        {
          "label": "פוקוס",
          "value": "pvkvs",
          "years": [
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022"
          ],
          "yearsByType": {
            "all": [
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022"
            ],
            "multimedia": [
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022"
            ]
          },
          "productTypes": [
            "multimedia"
          ],
          "coverageKey": "ford__pvkvs",
          "displayName": "פורד פוקוס"
        },
        {
          "label": "פיאסטה",
          "value": "pyasth",
          "years": [
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019"
          ],
          "yearsByType": {
            "all": [
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019"
            ],
            "multimedia": [
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019"
            ]
          },
          "productTypes": [
            "multimedia"
          ],
          "coverageKey": "ford__pyasth",
          "displayName": "פורד פיאסטה"
        },
        {
          "label": "קוגה",
          "value": "kvgh",
          "years": [
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019"
          ],
          "yearsByType": {
            "all": [
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019"
            ],
            "multimedia": [
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019"
            ]
          },
          "productTypes": [
            "multimedia"
          ],
          "coverageKey": "ford__kvgh",
          "displayName": "פורד קוגה"
        },
        {
          "label": "ריינגר",
          "value": "ranger",
          "years": [
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "ford__ranger",
          "displayName": "פורד ריינגר"
        }
      ]
    },
    {
      "label": "פיאט",
      "value": "fiat",
      "types": [
        "multimedia"
      ],
      "models": [
        {
          "label": "500",
          "value": "500",
          "years": [
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015"
          ],
          "yearsByType": {
            "all": [
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015"
            ],
            "multimedia": [
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015"
            ]
          },
          "productTypes": [
            "multimedia"
          ],
          "coverageKey": "fiat__500",
          "displayName": "פיאט 500"
        },
        {
          "label": "דובלו",
          "value": "dvblv",
          "years": [
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017"
          ],
          "yearsByType": {
            "all": [
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017"
            ],
            "multimedia": [
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017"
            ]
          },
          "productTypes": [
            "multimedia"
          ],
          "coverageKey": "fiat__dvblv",
          "displayName": "פיאט דובלו"
        },
        {
          "label": "דוקטו",
          "value": "dvktv",
          "years": [
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia"
          ],
          "coverageKey": "fiat__dvktv",
          "displayName": "פיאט דוקטו"
        }
      ]
    },
    {
      "label": "פיג'ו",
      "value": "peugeot",
      "types": [
        "window_lifter",
        "sunshade",
        "floor_mats"
      ],
      "models": [
        {
          "label": "2008",
          "value": "2008",
          "years": [
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "sunshade": [
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019"
            ]
          },
          "productTypes": [
            "sunshade",
            "floor_mats"
          ],
          "coverageKey": "peugeot__2008",
          "displayName": "פיג'ו 2008"
        },
        {
          "label": "208",
          "value": "208",
          "years": [
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "peugeot__208",
          "displayName": "פיג'ו 208"
        },
        {
          "label": "3008",
          "value": "3008",
          "years": [
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "sunshade": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023"
            ],
            "floor_mats": [
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter",
            "sunshade",
            "floor_mats"
          ],
          "coverageKey": "peugeot__3008",
          "displayName": "פיג'ו 3008"
        },
        {
          "label": "5008",
          "value": "5008",
          "years": [
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "sunshade": [
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter",
            "sunshade",
            "floor_mats"
          ],
          "coverageKey": "peugeot__5008",
          "displayName": "פיג'ו 5008"
        },
        {
          "label": "פאגרו",
          "value": "pajero",
          "years": [
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "peugeot__pajero",
          "displayName": "פיג'ו פאגרו"
        }
      ]
    },
    {
      "label": "צ'רי",
      "value": "chery",
      "types": [
        "sunshade"
      ],
      "models": [
        {
          "label": "טיגו 7",
          "value": "tygv-7",
          "years": [
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "sunshade": [
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "sunshade"
          ],
          "coverageKey": "chery__tygv-7",
          "displayName": "צ'רי טיגו 7"
        },
        {
          "label": "טיגו 8",
          "value": "tygv-8",
          "years": [
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "sunshade": [
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "sunshade"
          ],
          "coverageKey": "chery__tygv-8",
          "displayName": "צ'רי טיגו 8"
        }
      ]
    },
    {
      "label": "קאדילאק",
      "value": "cadillac",
      "types": [
        "window_lifter"
      ],
      "models": [
        {
          "label": "QEV",
          "value": "qev",
          "years": [
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "cadillac__qev",
          "displayName": "קאדילאק QEV"
        }
      ]
    },
    {
      "label": "קופרה",
      "value": "cupra",
      "types": [
        "window_lifter",
        "floor_mats"
      ],
      "models": [
        {
          "label": "אטקה\nלאון",
          "value": "atkhlavn",
          "years": [
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "floor_mats"
          ],
          "coverageKey": "cupra__atkhlavn",
          "displayName": "קופרה אטקה\nלאון"
        },
        {
          "label": "קופרה",
          "value": "cupra",
          "years": [
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "cupra__cupra",
          "displayName": "קופרה קופרה"
        }
      ]
    },
    {
      "label": "קיה",
      "value": "kia",
      "types": [
        "multimedia",
        "window_lifter",
        "sunshade",
        "floor_mats"
      ],
      "models": [
        {
          "label": "אופטימה",
          "value": "avptymh",
          "years": [
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018"
          ],
          "yearsByType": {
            "all": [
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018"
            ],
            "multimedia": [
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018"
            ]
          },
          "productTypes": [
            "multimedia"
          ],
          "coverageKey": "kia__avptymh",
          "displayName": "קיה אופטימה"
        },
        {
          "label": "אקסיד",
          "value": "xceed",
          "years": [
            "2019",
            "2020",
            "2021"
          ],
          "yearsByType": {
            "all": [
              "2019",
              "2020",
              "2021"
            ],
            "window_lifter": [
              "2019",
              "2020",
              "2021"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "kia__xceed",
          "displayName": "קיה אקסיד"
        },
        {
          "label": "נירו",
          "value": "nyrv",
          "years": [
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2016",
              "2017",
              "2018",
              "2019"
            ],
            "window_lifter": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "sunshade": [
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter",
            "sunshade",
            "floor_mats"
          ],
          "coverageKey": "kia__nyrv",
          "displayName": "קיה נירו"
        },
        {
          "label": "סול",
          "value": "svl",
          "years": [
            "2008",
            "2009",
            "2010",
            "2011",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020"
          ],
          "yearsByType": {
            "all": [
              "2008",
              "2009",
              "2010",
              "2011",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020"
            ],
            "multimedia": [
              "2008",
              "2009",
              "2010",
              "2011",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020"
            ]
          },
          "productTypes": [
            "multimedia"
          ],
          "coverageKey": "kia__svl",
          "displayName": "קיה סול"
        },
        {
          "label": "סורנטו",
          "value": "svrntv",
          "years": [
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2009",
              "2010",
              "2011",
              "2012",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020"
            ],
            "window_lifter": [
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter",
            "floor_mats"
          ],
          "coverageKey": "kia__svrntv",
          "displayName": "קיה סורנטו"
        },
        {
          "label": "סטוניק",
          "value": "stvnyk",
          "years": [
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "sunshade": [
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter",
            "sunshade",
            "floor_mats"
          ],
          "coverageKey": "kia__stvnyk",
          "displayName": "קיה סטוניק"
        },
        {
          "label": "סיד",
          "value": "syd",
          "years": [
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018"
            ],
            "window_lifter": [
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter",
            "floor_mats"
          ],
          "coverageKey": "kia__syd",
          "displayName": "קיה סיד"
        },
        {
          "label": "סלטוס",
          "value": "sltvs",
          "years": [
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter",
            "floor_mats"
          ],
          "coverageKey": "kia__sltvs",
          "displayName": "קיה סלטוס"
        },
        {
          "label": "ספורטאז׳",
          "value": "sportage",
          "years": [
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021"
            ],
            "window_lifter": [
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "sunshade": [
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter",
            "sunshade",
            "floor_mats"
          ],
          "coverageKey": "kia__sportage",
          "displayName": "קיה ספורטאז׳"
        },
        {
          "label": "פורטה",
          "value": "pvrth",
          "years": [
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018"
            ],
            "window_lifter": [
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter"
          ],
          "coverageKey": "kia__pvrth",
          "displayName": "קיה פורטה"
        },
        {
          "label": "פיקנטו",
          "value": "pykntv",
          "years": [
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "sunshade": [
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter",
            "sunshade"
          ],
          "coverageKey": "kia__pykntv",
          "displayName": "קיה פיקנטו"
        },
        {
          "label": "קארנס",
          "value": "karns",
          "years": [
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019"
          ],
          "yearsByType": {
            "all": [
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019"
            ],
            "multimedia": [
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019"
            ]
          },
          "productTypes": [
            "multimedia"
          ],
          "coverageKey": "kia__karns",
          "displayName": "קיה קארנס"
        },
        {
          "label": "קרניבל",
          "value": "krnybl",
          "years": [
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020"
            ],
            "window_lifter": [
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter"
          ],
          "coverageKey": "kia__krnybl",
          "displayName": "קיה קרניבל"
        },
        {
          "label": "ריו",
          "value": "ryv",
          "years": [
            "2002",
            "2003",
            "2004",
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022"
            ],
            "window_lifter": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter",
            "floor_mats"
          ],
          "coverageKey": "kia__ryv",
          "displayName": "קיה ריו"
        }
      ]
    },
    {
      "label": "רנו",
      "value": "renault",
      "types": [
        "window_lifter",
        "sunshade",
        "floor_mats"
      ],
      "models": [
        {
          "label": "מאסטר",
          "value": "master",
          "years": [
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "renault__master",
          "displayName": "רנו מאסטר"
        },
        {
          "label": "מגאן",
          "value": "mgan",
          "years": [
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "sunshade": [
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "sunshade",
            "floor_mats"
          ],
          "coverageKey": "renault__mgan",
          "displayName": "רנו מגאן"
        },
        {
          "label": "פלואנס",
          "value": "plvans",
          "years": [
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "floor_mats"
          ],
          "coverageKey": "renault__plvans",
          "displayName": "רנו פלואנס"
        },
        {
          "label": "קדג'אר",
          "value": "kdgar",
          "years": [
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "floor_mats"
          ],
          "coverageKey": "renault__kdgar",
          "displayName": "רנו קדג'אר"
        },
        {
          "label": "קוליאוס",
          "value": "koleos",
          "years": [
            "2023"
          ],
          "yearsByType": {
            "all": [
              "2023"
            ],
            "window_lifter": [
              "2023"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "renault__koleos",
          "displayName": "רנו קוליאוס"
        },
        {
          "label": "קליאו",
          "value": "clio",
          "years": [
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter",
            "floor_mats"
          ],
          "coverageKey": "renault__clio",
          "displayName": "רנו קליאו"
        },
        {
          "label": "קנגו",
          "value": "kngv",
          "years": [
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "floor_mats": [
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021"
            ]
          },
          "productTypes": [
            "window_lifter",
            "floor_mats"
          ],
          "coverageKey": "renault__kngv",
          "displayName": "רנו קנגו"
        },
        {
          "label": "קפצ'ור",
          "value": "kptsvr",
          "years": [
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020"
          ],
          "yearsByType": {
            "all": [
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020"
            ],
            "floor_mats": [
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020"
            ]
          },
          "productTypes": [
            "floor_mats"
          ],
          "coverageKey": "renault__kptsvr",
          "displayName": "רנו קפצ'ור"
        }
      ]
    },
    {
      "label": "שברולט",
      "value": "chevrolet",
      "types": [
        "multimedia",
        "window_lifter",
        "floor_mats"
      ],
      "models": [
        {
          "label": "אבאו",
          "value": "abav",
          "years": [
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022"
            ],
            "window_lifter": [
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter"
          ],
          "coverageKey": "chevrolet__abav",
          "displayName": "שברולט אבאו"
        },
        {
          "label": "אורלנדו",
          "value": "avrlndv",
          "years": [
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018"
          ],
          "yearsByType": {
            "all": [
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018"
            ],
            "multimedia": [
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018"
            ]
          },
          "productTypes": [
            "multimedia"
          ],
          "coverageKey": "chevrolet__avrlndv",
          "displayName": "שברולט אורלנדו"
        },
        {
          "label": "אקווינוקס",
          "value": "akvvynvks",
          "years": [
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024"
          ],
          "yearsByType": {
            "all": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024"
            ],
            "multimedia": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022"
            ],
            "window_lifter": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter"
          ],
          "coverageKey": "chevrolet__akvvynvks",
          "displayName": "שברולט אקווינוקס"
        },
        {
          "label": "בלייזר",
          "value": "blazer",
          "years": [
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024"
          ],
          "yearsByType": {
            "all": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024"
            ],
            "window_lifter": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "chevrolet__blazer",
          "displayName": "שברולט בלייזר"
        },
        {
          "label": "האמר",
          "value": "hummer",
          "years": [
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2024",
              "2025"
            ],
            "window_lifter": [
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "chevrolet__hummer",
          "displayName": "שברולט האמר"
        },
        {
          "label": "טראקס",
          "value": "traks",
          "years": [
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019"
            ],
            "window_lifter": [
              "2013",
              "2014",
              "2015",
              "2016",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter"
          ],
          "coverageKey": "chevrolet__traks",
          "displayName": "שברולט טראקס"
        },
        {
          "label": "טרוורס",
          "value": "traverse",
          "years": [
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024"
          ],
          "yearsByType": {
            "all": [
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024"
            ],
            "multimedia": [
              "2014",
              "2015",
              "2016",
              "2017",
              "2018"
            ],
            "window_lifter": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter"
          ],
          "coverageKey": "chevrolet__traverse",
          "displayName": "שברולט טרוורס"
        },
        {
          "label": "טרייל בלייזר",
          "value": "trailblazer",
          "years": [
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024"
          ],
          "yearsByType": {
            "all": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024"
            ],
            "window_lifter": [
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024"
            ]
          },
          "productTypes": [
            "window_lifter"
          ],
          "coverageKey": "chevrolet__trailblazer",
          "displayName": "שברולט טרייל בלייזר"
        },
        {
          "label": "מאליבו",
          "value": "malybv",
          "years": [
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024"
          ],
          "yearsByType": {
            "all": [
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024"
            ],
            "multimedia": [
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020"
            ],
            "window_lifter": [
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter"
          ],
          "coverageKey": "chevrolet__malybv",
          "displayName": "שברולט מאליבו"
        },
        {
          "label": "סוניק",
          "value": "svnyk",
          "years": [
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021"
            ],
            "window_lifter": [
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter"
          ],
          "coverageKey": "chevrolet__svnyk",
          "displayName": "שברולט סוניק"
        },
        {
          "label": "סילברדו",
          "value": "silverado",
          "years": [
            "2005",
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019"
            ],
            "window_lifter": [
              "2013",
              "2014",
              "2015",
              "2016"
            ],
            "floor_mats": [
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter",
            "floor_mats"
          ],
          "coverageKey": "chevrolet__silverado",
          "displayName": "שברולט סילברדו"
        },
        {
          "label": "ספארק",
          "value": "spark",
          "years": [
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
            "2023",
            "2024",
            "2025"
          ],
          "yearsByType": {
            "all": [
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ],
            "multimedia": [
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020"
            ],
            "window_lifter": [
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
              "2023",
              "2024",
              "2025"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter"
          ],
          "coverageKey": "chevrolet__spark",
          "displayName": "שברולט ספארק"
        },
        {
          "label": "קפטיבה",
          "value": "kptybh",
          "years": [
            "2006",
            "2007",
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019"
          ],
          "yearsByType": {
            "all": [
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019"
            ],
            "multimedia": [
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019"
            ]
          },
          "productTypes": [
            "multimedia"
          ],
          "coverageKey": "chevrolet__kptybh",
          "displayName": "שברולט קפטיבה"
        },
        {
          "label": "קרוז",
          "value": "krvz",
          "years": [
            "2008",
            "2009",
            "2010",
            "2011",
            "2012",
            "2013",
            "2014",
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020"
          ],
          "yearsByType": {
            "all": [
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020"
            ],
            "multimedia": [
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020"
            ],
            "window_lifter": [
              "2013",
              "2014",
              "2015",
              "2016"
            ]
          },
          "productTypes": [
            "multimedia",
            "window_lifter"
          ],
          "coverageKey": "chevrolet__krvz",
          "displayName": "שברולט קרוז"
        }
      ]
    }
  ]
};
